<template>
  <CalculationElementLayout :node-id="nodeId">
    <v-row>
      <v-col>
        <v-container class="bordered bg-white">
          <CalcInputNumber
            :id="nodeId"
            class="mb-4"
            field="tool_costs_tool"
            :rules="[required, positive]" />
        </v-container>
      </v-col>
      <v-col>
        <v-container class="bordered bg-white">
          <NotesEditor
            :id="nodeId"
            field="comment"
            :placeholder="$t('entities.material.fields.comment')" />
        </v-container>
      </v-col>
    </v-row>
  </CalculationElementLayout>
</template>

<script setup>
import { computed } from "vue";
import { useTranslation } from "i18next-vue";
import { useRoute } from "vue-router";

import { useCommonRules } from "@/validations/common";

import CalculationElementLayout from "@/layouts/CalculationElementLayout.vue";
import NotesEditor from "@/components/Elements/NotesEditor.vue";
import CalcInputNumber from "@/components/Elements/CalcInputNumber.vue";

const { t } = useTranslation();
const { required, positive } = useCommonRules(t);
const route = useRoute();

const nodeId = computed(() => route.params.nodeId);
</script>
